export default __webpack_public_path__ + "static/po-system3-7e8a210fd25748417c23125a20fc6649.png";